import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import Input from '@/common/components/Input';
import { SearchBarRaw } from '@/common/styles/SearchBars';
import useSearchBox from '../hooks/useSearchBox';
import SelectInput from '@/common/components/SelectInput';

const ProfitabilitySearchBox = ({ handleSearchCallback }) => {
	const hook = useSearchBox({ handleSearchCallback });

	return (
		<SearchBarRaw>
			<div>
				<Input
					name='From date'
					width={180}
					color={Colors.darkBlue}
					inputRef={hook.dateFromRef}
					type='date'
					value={hook.today}
					inputWidth={140}
					hasIncDec
				/>
				<Input
					name='To date'
					width={180}
					color={Colors.darkBlue}
					inputRef={hook.dateToRef}
					type='date'
					value={hook.today}
					inputWidth={140}
					hasIncDec
				/>
			</div>
			<SelectInput
				name='Markets'
				options={hook.marketsOptions}
				color={Colors.darkBlue}
				width={100}
				setSelected={hook.setSelectedMarkets}
				selected={hook.selectedMarkets}
				multiple={true}
				selectWidth={320}
			/>
			<ActionButton text='Search' onClick={(e) => hook.handleSearch(e)} />
		</SearchBarRaw>
	);
};

export default ProfitabilitySearchBox;
